import RichText from "@components/rich-text/renderer"
import { MikanSpan } from "@components/Mikan"

const Text = ({ content }) => {
  const html = content.content && content.content.childMarkdownRemark.html

  if (html) {
    return <MikanSpan>{html}</MikanSpan>
  } else if (content.rtContent) {
    return <RichText body={content.rtContent} mikan={content.mikan} />
  } else {
    return <></>
  }
}

export default Text
